/*
 * @Author: your name
 * @Date: 2021-12-28 13:36:36
 * @LastEditTime: 2022-08-15 21:00:17
 * @LastEditTime: 2022-07-22 16:54:24
 * @LastEditors: 牛字杰 niuzijie@.jtexpress
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \yl-wxcx-coupon-front\src\@public\http\request.js
 */
/*
 * @Description: http请求封装
 */
import axios from 'axios'
import router from '@/router/index'
import store from '@/store'
import Vue from 'vue'
// const IS_DEVELOPMENT = process.env.NODE_ENV === 'development' // 是否开发环境
const self = new Vue()

let baseURL = process.env.VUE_APP_API_URL_DY
const host = window.location.host
const uatURL = 'uat-coupon.jtexpress.com.cn'
if (host === uatURL) {
  // 如果当前环境在UAT
  baseURL = 'https://uat-dyapplets.jtexpress.com.cn'
}
// 创建axios实例
const service = axios.create({
  baseURL,
})
// 设置请求的基础路径
service.defaults.withCredentials = false
// service.defaults.baseURL = process.env.VUE_APP_API_URL_DY // 开发环境使用反向代理

// 超时时间
service.defaults.timeout = 15000
// request拦截器
service.interceptors.request.use(config => {
  // 获取vuex的token
  const { token = '' } = store.getters

  config.data = config.data || {}
  console.log(config.data)
  // 获取当前路由名称
  // const routeName = router.history.current.name
  // 设置请求头authToken
  config.headers.authToken = token
  // 设置请求头routeName
  // config.headers.routeName = routeName
  //  设置了缓存，如果请求参数没变又要实时返回，请在请求后面加时间戳
  config.headers['Cache-Control'] = 'max-age=2, must-revalidate'
  return config
// eslint-disable-next-line no-sequences
}), (error) => {
  return Promise.reject(error)
}
// respone拦截器
service.interceptors.response.use((response) => {
  if (response.status === 200) {
    var res = response.data
    if (response.data.code === 149010008) {
      store.dispatch('LOGIN_OUT').then(() => {
        router.push({ name: 'Login' })
        // self.$message.error('没有访问权限，请重新登录')
      })
    }
    // else if(response.data.code === 500){
    //   store.dispatch('LOGIN_OUT').then(() => {
    //     router.push({ name: 'Login' })
    //   })
    // }
    return res
  }
}, error => {
  console.log('error.response', error.response.data.code)
  if (error.response.data.code === 500) {
    self.$message.error(self.$lang(error.response.data.msg))
    // store.dispatch('LOGIN_OUT').then(() => {
    //   router.push({ name: 'Login' })
    //   return Promise.reject(error)
    // })
  }
  if (error.response.data.code === 401 || error.response.data.code === 403) {
    store.dispatch('LOGIN_OUT').then(() => {
      self.$message.error(self.$lang(error.response.data.msg))
      setTimeout(() => {
        // 退出
        localStorage.removeItem('account')
        router.push({ name: 'Login' })
      }, 3000)
    })
  }
})
export const get = (url, params) => service.get(url, { params })
export const postDY = service.post
export const put = service.put
export const del = service.delete

export default service
